/**
 * Swipe-gesture thresholds and the decision they feed, split out from
 * `InvestigationsCarousel` so the rule can be unit-tested without simulating
 * pointer streams through Framer Motion (which jsdom models poorly).
 */

/**
 * How far (px) or how fast (px/s) a horizontal drag must be to count as a
 * swipe. Offset alone is not enough — a short, quick flick should page just
 * like a long, slow drag — so either crossing its threshold is sufficient.
 */
export const SWIPE_OFFSET_THRESHOLD = 60
export const SWIPE_VELOCITY_THRESHOLD = 400

export type SwipeOutcome = 'next' | 'prev' | 'none'

/**
 * Maps the horizontal offset and velocity of a finished drag onto the slide
 * to show. Dragging LEFT (negative offset) advances to the next slide, so the
 * content tracks the direction the finger moved.
 */
export const resolveSwipe = (offsetX: number, velocityX: number): SwipeOutcome => {
  const farEnough = Math.abs(offsetX) > SWIPE_OFFSET_THRESHOLD
  const fastEnough = Math.abs(velocityX) > SWIPE_VELOCITY_THRESHOLD

  if (!farEnough && !fastEnough) return 'none'

  // A flick that is fast but barely moved takes its direction from velocity,
  // which is the only meaningful signal in that case.
  const direction = farEnough ? offsetX : velocityX

  return direction < 0 ? 'next' : 'prev'
}
